import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

const TableReport = ({
  documents,
  onView,
  intestazioni = [],
  onDownload,
  isLoading,
}) => {
  const truncateFileName = (name, max = 50) => {
    if (!name) return "";
    return name.length > max ? name.slice(0, max) + "..." : name;
  };

  const formatDateIT = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("it-IT");
  };

  if (isLoading)
    return (
      <>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress sx={{ color: "#fff" }} />
        </div>
      </>
    );

  return (
    <>
      {Array.isArray(documents) && documents.length > 0 ? (
        <TableContainer
          component={Paper}
          sx={{
            overflowX: "auto",
            borderRadius: "16px",
            mt: "20px",
            mb: "34px",
          }}
        >
          <Table
            size="small"
            sx={{
              width: "100%",
              minWidth: "600px",
              tableLayout: { xs: "", md: "fixed" },
            }}
          >
            <TableHead>
              <TableRow className="bg-blue-dark">
                {intestazioni.map((col) => (
                  <TableCell
                    key={col.key}
                    sx={{
                      fontWeight: 600,
                      textAlign: "center",
                      borderRight: "1px solid #fff",
                      fontSize: "15px",
                      width:
                        col.key === "id" || col.key === "actions"
                          ? "40px"
                          : col.key === "reader" || col.key === "datario"
                            ? "100px"
                            : "300px",
                    }}
                  >
                    <Typography className="color-light">{col.label}</Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {documents.map((item, index) => (
                <TableRow key={index} sx={{ height: "40px !important" }}>
                  {intestazioni.map((col) => {
                    if (col.key === "actions") {
                      return (
                        <TableCell
                          key={col.key}
                          sx={{
                            textAlign: "center",
                            width: "100px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <Box
                              onClick={() => onView(item)}
                              className="icon-update-report"
                              sx={{ cursor: "pointer" }}
                            />
                          </Box>
                        </TableCell>
                      );
                    }

                    if (col.key === "original_name") {
                      return (
                        <TableCell
                          key={col.key}
                          align="left"
                          sx={{ width: "300px" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "10px",
                              width: "100%",
                              cursor: "pointer",
                              marginLeft: "0px",
                            }}
                          >
                            <Box
                              className="icon-dowload-report"
                              sx={{
                                width: "20px",
                                height: "20px",
                                flexShrink: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            />

                            <Typography
                              className="color-purple"
                              onClick={() => onDownload(item)}
                              sx={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {truncateFileName(item[col.key], 50)}
                            </Typography>
                          </Box>
                        </TableCell>
                      );
                    }

                    return (
                      <TableCell
                        key={col.key}
                        sx={{
                          fontWeight: 600,
                          textAlign: "center",
                          borderRight: "1px solid #fff",
                          fontSize: "15px",
                          width:
                            col.key === "reader"
                              ? "180px"
                              : col.key === "datario"
                                ? "100px"
                                : "300px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Typography className="color-blue-dark">
                          {col.key === "datario"
                            ? formatDateIT(item[col.key])
                            : col.key === "subject_reader_id"
                              ? (item.subject_reader?.name ?? "-")
                              : item[col.key]}
                        </Typography>
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography className="color-blue-dark" style={{ fontWeight: 500 }}>
          Nessun report disponibile
        </Typography>
      )}
    </>
  );
};

export default TableReport;
